export enum Language {
    EN = 'EN',
    LT = 'LT',
    RU = 'RU',
}

export enum Type {
    _3D = '3D',
    _360 = '360',
    _Other = 'Other',
}

export enum YesNo {
    yes = 'Yes',
    no = 'No',
}

export enum StorageKey {
    isAuthenticated = 'isAuthenticated',
    baseInfo = 'baseInfo',
    launcherUpdateDismissed = 'launcherUpdateDismissed',
}

export enum LessonType {
    survey = 'Survey',
    text = 'Text',
    virtual_3d = '3D',
    pdf = 'PDF',
}

export enum SurveyType {
    survey = 'Survey',
    quiz = 'Quiz',
    exam = 'Exam',
}

export enum QuizMode {
    survey = 'SURVEY',
    quiz = 'QUIZ',
    exam = 'EXAM',
}

export enum QuestionType {
    singleSelect = 'Single Select',
    multiSelect = 'Multi Select',
    connectingDots = 'Connecting Dots',
    dragDrop = 'Drag & Drop Groups',
    text = 'Free text',
    rating = 'Rating',
    yesNo = 'Yes/No',
}

export enum OperatorType {
    le = 'le',
    ge = 'ge',
    default = 'default',
}

export enum LoaderType {
    validateToken = 'validateToken',
    logout = 'logout',
    userBase = 'userBase',
    createLessonAttempt = 'createLessonAttempt',
    createQuizAttempt = 'createQuizAttempt',
    getProgram = 'getProgram',
    getComputers = 'getComputers',
    createSocket = 'createSocket',
    createAnswer = 'createAnswer',
    getPrograms = 'getPrograms',
    getUserSettings = 'getUserSettings',
    updateUserSettings = 'updateUserSettings',
    updatePassword = 'updatePassword',
    getTournament = 'getTournament',
    getTournamentComputers = 'getTournamentComputers',
    createSocketTournament = 'createSocketTournament',
    getAssignments = 'getAssignments',
    getTournaments = 'getTournaments',
    getAssignment = 'getAssignment',
    getQuizData = 'getQuizData',
    getKPIResults = 'getKPIResults',
    listUsers = 'listUsers',
    createAnswerQuiz = 'createAnswerQuiz',
    createAnswerDragDropQuiz = 'createAnswerDragDropQuiz',
    getUsers = 'getUsers',
    getAssignmentsPrograms = 'getAssignmentsPrograms',
    getAssignmentTypes = 'getAssignmentTypes',
    createAssignment = 'createAssignment',
    updateAssignment = 'updateAssignment',
    selectSimulator = 'selectSimulator',
    getFilterValues = 'getFilterValues',
    getMainKPIsValues = 'getMainKPIsValues',
    getDriverDetailsValues = 'getDriverDetailsValues',
    saveUserNotes = 'saveUserNotes',
    saveLessonCustomConfig = 'saveLessonCustomConfig',
    deactivateAssignment = 'deactivateAssignment',
    bulkImportValidate = 'bulkImportValidate',
    bulkImportCreate = 'bulkImportCreate',
    createUser = 'createUser',
    getUser = 'getUser',
    updateUser = 'updateUser',
    sendReset = 'sendReset',
    listGroups = 'listGroups',
    removeGroup = 'removeGroup',
    createGroup = 'createGroup',
    getGroup = 'getGroup',
    updateGroup = 'updateGroup',
}

export enum TournamentStatus {
    completed = 'COMPLETED',
    notStarted = 'NOT STARTED',
    inProgress = 'IN PROGRESS',
}

export enum AssignmentStatus {
    draft = 'Draft',
    active = 'Active',
    inactive = 'Inactive',
}

export enum DurationType {
    days = 'Days',
    weeks = 'Weeks',
    months = 'Months',
}

export enum AssignementDurationType {
    dueDate = 'dueDate',
    duration = 'duration',
}
